import { Layers } from 'lucide-react';
import { cn } from '@/lib/cn';

/** The Light BM mark, or the company logo when one is uploaded. */
export function BrandMark({ logoUrl, className }: { logoUrl?: string | null; className?: string }) {
  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt=""
        className={cn(
          'size-12 shrink-0 rounded-[12px] border border-line bg-surface object-contain p-1',
          className,
        )}
      />
    );
  }
  return (
    <span
      aria-hidden="true"
      className={cn(
        'flex size-12 shrink-0 items-center justify-center rounded-[12px] bg-primary text-white',
        className,
      )}
    >
      <Layers className="size-6" strokeWidth={1.9} />
    </span>
  );
}
